import { Controller } from "@hotwired/stimulus";

// Wheel-scrolls a non-interactive preview iframe. The iframe keeps
// pointer-events: none (no accidental navigation inside a mini
// preview), so the wrapper catches the wheel and proxies it into the
// same-origin frame's scroll position.
export default class extends Controller {
  static targets = ["frame"];

  connect() {
    this.onWheel = (event) => {
      if (!this.hasFrameTarget) return;
      // Ctrl/cmd+wheel is pinch/browser zoom — never swallow it.
      if (event.ctrlKey || event.metaKey) return;
      event.preventDefault();
      // deltaMode 1 = lines (Firefox), 2 = pages — scale to pixels or
      // the proxied scroll is imperceptible.
      const scale = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? this.element.clientHeight : 1;
      try {
        this.frameTarget.contentWindow.scrollBy(event.deltaX * scale, event.deltaY * scale);
      } catch (_) {
        /* cross-origin or not yet loaded — ignore */
      }
    };
    this.element.addEventListener("wheel", this.onWheel, { passive: false });
  }

  disconnect() {
    this.element.removeEventListener("wheel", this.onWheel);
  }
}
